type LogLevel = 'debug' | 'info' | 'warn' | 'error';

type LogContext = Record<string, unknown>;

function shouldLog(level: LogLevel): boolean {
  if (import.meta.env.PROD && (level === 'debug' || level === 'info')) {
    return false;
  }
  return true;
}

function formatMessage(level: LogLevel, message: string, context?: LogContext): string {
  const timestamp = new Date().toISOString();
  return `[${timestamp}] [${level.toUpperCase()}] ${message}${context ? ` ${JSON.stringify(context)}` : ''}`;
}

function sanitize(context?: LogContext): LogContext | undefined {
  if (!context) return undefined;
  const sanitized = { ...context };
  const sensitiveKeys = ['token', 'password', 'secret', 'authorization', 'cookie'];
  for (const key of Object.keys(sanitized)) {
    if (sensitiveKeys.some((s) => key.toLowerCase().includes(s))) {
      sanitized[key] = '[REDACTED]';
    }
  }
  return sanitized;
}

export const logger = {
  debug(message: string, context?: LogContext) {
    if (!shouldLog('debug')) return;
    console.debug(formatMessage('debug', message, sanitize(context)));
  },

  info(message: string, context?: LogContext) {
    if (!shouldLog('info')) return;
    console.info(formatMessage('info', message, sanitize(context)));
  },

  warn(message: string, context?: LogContext) {
    if (!shouldLog('warn')) return;
    console.warn(formatMessage('warn', message, sanitize(context)));
  },

  error(message: string, context?: LogContext) {
    if (!shouldLog('error')) return;
    console.error(formatMessage('error', message, sanitize(context)));
  },
};
